<template lang="slm">
section.Campaign.is-nopic
	.container
		.columns
			.column.is-8.is-offset-2.is-8-desktop.is-offset-2-desktop
				.Campaign-textBox
					a :href="link"
						.Campaign-content
							h2.Campaign-heading.title {{text}}
							.Campaign-readMore.trailingarrow {{ctaText}}
</template>

<script>

export default {
  props: ['text', 'ctaText', 'link']
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/CampaignNoPic.vue